// Crowd Monitoring palette — shared Vigilo palette with a brighter text hierarchy for
// command-centre viewing distance. Scoped to this app only: @vigilo/design-system
// (used by the other Vigilo apps) is untouched.
//
//   text   near-white  headline values, names, active items
//   sub    ~74% white  secondary: captions, units, context lines, inactive nav
//   muted  ~50% white  metadata tier: timestamps, thresholds, axes, footnotes
import { getC, type ColorPalette } from '@vigilo/design-system';

const CROWD_DARK_OVERRIDES: Partial<ColorPalette> = {
  text:  '#FAFCFF',
  sub:   'rgba(232,238,247,0.74)',
  muted: 'rgba(232,238,247,0.50)',
};

export function getCrowdC(theme: 'dark' | 'light'): ColorPalette {
  const base = getC(theme);
  return theme === 'dark' ? { ...base, ...CROWD_DARK_OVERRIDES } : base;
}

// Operation lifecycle colours — mirrors the Operations register so the same status reads the
// same on every screen: active green, paused amber, scheduled teal, closed ember.
export function operationStatusColor(C: ColorPalette, status: string | undefined): string {
  if (status === 'active') return C.green;
  if (status === 'paused') return C.amber;
  if (status === 'scheduled') return C.teal;
  if (status === 'closed') return C.ember;
  return C.muted;
}
